import type { FaireProductEntity } from "../../entity_types/product";

export const p_1h9isy79: FaireProductEntity = {
  token: "p_1h9isy79",
  type: "product",
  name: "Gracias Luchador Thank You Greeting Card",
  brandToken: "b_6pxaaxfg",
  brandName: "La Familia Green",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/6fc3750e1d9dadec8533dfac1f1ad47fda594a01901683419d1ba91eade7a2ef/1535728024.jpg",
  galleryImageUrls: [],
  priceDollars: 3,
  description:
    'That familiar luchador returns to help you say thank you with a very enthusiastic double thumbs up.\n\nFlat printed on FSC certified paper from an original handcut collage, drawing, or print. \n\n4.25" x 5.5" folded card with recycled kraft envelope\n\nBlank inside\n\nMade in USA',
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:09.682Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
